require('./mortgageRequestSimpleNoteRequestStep1.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { get, chain } = require('lodash');
//@ components
const MortgageRequestSimpleNoteConstructions = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteConstructions/mortgageRequestSimpleNoteConstructions');
const MortgageRequestSimpleNoteAddress = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteAddressFormat/mortgageRequestSimpleNoteAddressFormat');
const MortgageRequestSimpleNoteRequestCostWafer = require('components/mortgageRequest/mortgageRequestSimpleNote/mortgageRequestSimpleNoteRequest/mortgageRequestSimpleNoteRequestCostWafer/mortgageRequestSimpleNoteRequestCostWafer');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
// @ constants
const { ESTATES_TYPE } = require('constants/mortgageRequestHolderData');
// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;

class MortgageRequestSimpleNoteRequestStep1 extends React.Component {
    constructor(props) {
        super(props);

        this.buildLivingPlaceEstateWrapper = this.buildLivingPlaceEstateWrapper.bind(this);
        this.buildUdifirWrapper = this.buildUdifirWrapper.bind(this);
    }

    buildIncludedEstates(garages, storageRooms) {
        const garagesText = garages && garages > 0 && `${garages} ${formatText('mortgageRequestSimpleNoteRequest-step1Garages')}`;
        const storageRoomsText = storageRooms && storageRooms > 0 && `${storageRooms} ${formatText('mortgageRequestSimpleNoteRequest-step1StorageRoom')}`;

        let includedEstatesHtml;
        if (garagesText && storageRoomsText) {
            includedEstatesHtml = (
                <p className="mortgage-request-simple-note-request-step-one__item">
                    {formatText('mortgageRequestSimpleNoteRequest-step1Includes', [storageRoomsText, garagesText])}
                </p>
            );
        } else if (garagesText) {
            includedEstatesHtml = (
                <p className="mortgage-request-simple-note-request-step-one__item">
                    {formatText('mortgageRequestSimpleNoteRequest-step1Include', [garagesText])}
                </p>
            );
        } else if (storageRoomsText) {
            includedEstatesHtml = (
                <p className="mortgage-request-simple-note-request-step-one__item">
                    {formatText('mortgageRequestSimpleNoteRequest-step1Include', [storageRoomsText])}
                </p>
            );
        }

        return includedEstatesHtml;
    }

    buildLivingPlaceEstateWrapper(item) {
        const udifir = get(item, 'udifir', '');
        const storageRooms = get(item, 'storageRooms', '');
        const garages = get(item, 'garages', '');
        const udifirWrapper = this.buildUdifirWrapper(udifir);
        const includedEstatesWrapper = this.buildIncludedEstates(garages, storageRooms);

        return (
            <div>
                <MortgageRequestSimpleNoteAddress
                    completeItem={item}
                />

                {udifirWrapper}

                {includedEstatesWrapper}
            </div>
        );
    }

    buildUdifirWrapper(udifir) {
        return udifir && (
            <div>
                <p className="mortgage-request-simple-note-request-step-one__item">
                    {formatText('mortgageRequestSimpleNoteRequest-step1Code')}
                </p>

                <p className="mortgage-request-simple-note-request-step-one__label">
                    {udifir}
                </p>
            </div>
        );
    }

    render() {
        const {
            immEstates,
            immPayment,
            summaryDocumentation
        } = this.props;
        const estatesListData = immEstates.get('list');
        const simpleNoteCost = immPayment.get('simpleNoteCost');
        const authorizationPayment = formatText('mortgageRequestSimpleNoteRequest-mortgageRequestSimpleNoteRequest_authorizationPayment');
        let livingPlaceState = null;
        let otherEstatesTitle = false;
        const item = chain(estatesListData.toJS()).filter(estate =>
            estate.tipoBien === ESTATES_TYPE.VIVIENDA && !(estate.notaSimplePropia)).last().value();

        if (item) {
            livingPlaceState = this.buildLivingPlaceEstateWrapper(item);
            otherEstatesTitle = true;
        }

        let content;

        content = <LoadingSection />;

        if (immEstates.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            content = (
                <div className="mortgage-request-simple-note-request-step-one">
                    <h3 className="mortgage-request-simple-note-request-step-one__title">
                        {formatText('mortgageRequestSimpleNoteRequest-step1Title')}
                    </h3>
                    <p className="mortgage-request-simple-note-request-step-one__description">
                        {formatText('mortgageRequestSimpleNoteRequest-step1Description')}
                    </p>
                    {livingPlaceState}
                    <MortgageRequestSimpleNoteConstructions
                        immEstates={immEstates}
                        showTitle={otherEstatesTitle}
                    />
                    <MortgageRequestSimpleNoteRequestCostWafer
                        immEstates={immEstates}
                        simpleNoteCost={simpleNoteCost}
                        summaryDocumentation={summaryDocumentation}
                    />
                    <div className="mortgage-request-simple-note-request-step-one__important-msg">
                        <OKMessage type="important">
                            {authorizationPayment}
                        </OKMessage>
                    </div>
                    <div className="mortgage-request-simple-note-request-step-one__disclaimer-information-duty">
                        <OKMessage type="informative">
                            <FormattedText value="mortgageRequestSimpleNoteRequest-mortgageRequestSimpleNoteRequest_disclaimerInformationDuty" />
                        </OKMessage>
                    </div>
                </div>
            );
        }

        return content;
    }
}

MortgageRequestSimpleNoteRequestStep1.propTypes = {
    immEstates: PropTypes.object.isRequired,
    immPayment: PropTypes.object.isRequired,
    summaryDocumentation: PropTypes.object.isRequired
};

module.exports = MortgageRequestSimpleNoteRequestStep1;
